import ENV_VARS from '@/config'
import { get, put, post, del } from '@/ports/api'
const { BACKEND_SERVER } = ENV_VARS

// Renter - Billing Address
export const updateBillingAddress = put(`${BACKEND_SERVER}/settlements/billing_address`)
export const getBillingAddress = get(`${BACKEND_SERVER}/settlements/billing_address`)
export const deleteBillingAddress = del(`${BACKEND_SERVER}/settlements/billing_address`)

// Renter - Make Payment
export const makePayment = post(`${BACKEND_SERVER}/settlements/make_payment/%paymentRequestId%`)

// Renter - PAD
export const updatePad = put(`${BACKEND_SERVER}/settlements/pad/connect_and_sign`)
export const connectPad = put(`${BACKEND_SERVER}/settlements/pad/connect`)
export const getPad = get(`${BACKEND_SERVER}/settlements/pad`)
export const deletePad = del(`${BACKEND_SERVER}/settlements/pad`)

// Landlord - Payout - UnionPay
export const updateUnionPayPayout = put(`${BACKEND_SERVER}/settlements/payout/upop`)
export const getUnionPayPayout = get(`${BACKEND_SERVER}/settlements/payout/upop`, {
  failSilently: true
})
export const deleteUnionPayPayout = del(`${BACKEND_SERVER}/settlements/payout/upop`)

// Landlord - Payout - Stripe
export const getStripePayout = get(`${BACKEND_SERVER}/settlements/payout/stripe`)
export const deleteStripePayout = del(`${BACKEND_SERVER}/settlements/payout/stripe`)

// landlord - Payout - Verify deletion
export const verifyPayoutDeletion = get(`${BACKEND_SERVER}/settlements/payout/deletion_verify`)

export const getReviewPadContracts = get(
  `${BACKEND_SERVER}/settlements/pad/signature_required_contracts`
)

export const getFirstPadDate = post(`${BACKEND_SERVER}/settlements/pad/first_pad_date/%contractId%`)

export const signPadRequest = post(`${BACKEND_SERVER}/settlements/pad/sign`)
